import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "client/api/_keys";
import { Routes } from "client/api/_routes";

interface ProductsReqT {
  pageParam?: number;
  id?: number;
  title?: string;
  discount?: 0 | 1;
}

const products = async (params: ProductsReqT) => {
  const qs = `?page=${params.pageParam ?? 1}&title=${
    params.title ?? ""
  }&discount=${params.discount}`;
  return axios.get(
    Routes.CATEGORY_PREFIX + "/" + params.id + "/" + Routes.PRODUCTS + qs
  );
};

export const useProducts = (params: ProductsReqT) => {
  const { id, title, discount } = params;
  return useInfiniteQuery({
    queryKey: [Keys.PRODUCTS_QRY, id, title, discount],
    queryFn: ({ pageParam = 1 }) =>
      products({ pageParam, title, id, discount }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
